module.exports = {
	'customFolder.m4.m410300': {
		'childrenSNames': '子女姓名',
		'childrenSAge': '子女年龄',
		'totalAppliedParentalLeaveServiceYears': '总申请育婴留停年资',
		'applyByDate': '按日申请',
		'lessThanMonths': '未满 6 个月',
		'moreThanMonths': '6 个月以上',
		'parentalLeaveTenure': '育婴留停年资',
		'leaveWithoutPayHasApplied': '<%=name%>已被留职停薪套用，无法删除',
		'leaveWithoutPayHasApplied2': '<%=name%>已被留职停薪套用，无法异动',
	},
	'customFolder.m3.m310600': {
		'childrenYearsOld': '子女<%=temp1%>年龄',
	},
	'customFolder.service.m3.service-m310600': {
		'detailedListOfEmployeeEligibilityFor': '部属育婴留停纪录明细表',
	},
};
